import * as React from "react";
import { PropsWithChildren } from "react";
import { Header } from "./Header/Header";
import { Body } from "./Body/Body";
import { useStyles } from "./Layout.styles";

interface LayoutProps {}

export function Layout(props: PropsWithChildren<LayoutProps>) {
  const classes = useStyles();
  return <div className={classes.root}>{props.children}</div>;
}

Layout.Header = Header;
Layout.Body = Body;
